import { utils } from '@weapp/ui';
import { classnames } from '@weapp/utils';
import React, { PureComponent } from 'react';
import { When } from 'react-if';
import { LayoutType, pageViewClsPrefix } from '../../constants';
import { initMPageStyle } from '../../utils/page-style';
import BackgroundMask from './BackgroundMask';
import { MStyledProps, StyledStates } from './types';
import { getIsEmptyPageBgConfig } from './utils';

export default class Styled extends PureComponent<MStyledProps, StyledStates> {
  ref = React.createRef<HTMLDivElement>();

  componentDidMount() {
    initMPageStyle(this.props.data, LayoutType.GridLayout, this.props.scopeId as string);
    this.props.mounted?.(this.ref.current!);
  }

  getSnapshotBeforeUpdate(prevProps: MStyledProps) {
    const { data, scopeId } = this.props;

    if (!utils.isEqual(data, prevProps.data)) {
      initMPageStyle(data, LayoutType.GridLayout, scopeId as string);
    }
  }

  render() {
    const {
      pageBgConfig, className = '', scopeId, children,
    } = this.props;
    const clsNameStr = `${className}`.trim();
    const isEmptyPageBgConfig = getIsEmptyPageBgConfig(pageBgConfig);

    return (
      <div
        // 针对 ebpage 的类名做特殊处理，使用户可修改scope层的样式
        className={classnames(`${clsNameStr} ${pageViewClsPrefix}-container`.trim())}
        id={scopeId || ''}
        ref={this.ref}
      >
        <When weId={`${this.props.weId || ''}_6a08sw`} condition={!isEmptyPageBgConfig}>
          <BackgroundMask
            weId={`${this.props.weId || ''}_l5m7gb`}
            pageBgConfig={pageBgConfig}
            clientType="MOBILE"
          />
        </When>
        {children}
      </div>
    );
  }
}
